import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {SharedModule} from "../shared/shared.module";
import {CoreModule} from "../core/core.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {FacturesRoutingModule} from "./factures-routing.module";
import {FacturesFournisseursComponent} from "./fournisseurs/factures/factures-fournisseurs.component";
import {FacturesRootComponent} from "./factures-root.component";
import {
  DxAccordionModule,
  DxButtonGroupModule,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDateBoxModule, DxListModule, DxLookupModule, DxNumberBoxModule,
  DxPopupModule, DxRadioGroupModule, DxScrollViewModule, DxSelectBoxModule, DxTabPanelModule,
  DxTagBoxModule, DxTextAreaModule,
  DxTextBoxModule,
  DxToolbarModule, DxTreeViewModule
} from "devextreme-angular";

import {DialogJoinBonReceptionComponent} from "./fournisseurs/factures/dialog-join-bon-reception/dialog-join-bon-reception.component";
import {DialogDetailsInvoiceComponent} from "./fournisseurs/factures/dialog-details-invoice/dialog-details-invoice.component";
import {AvoirFournisseurComponent} from "./fournisseurs/avoirs/avoir-fournisseur.component";
import {AvoirFournisseurDetailsDialogComponent} from "./fournisseurs/avoirs/dialog-edition/avoir-fournisseur-details-dialog.component";
import {PointFacturationComponent} from "./clients/points-facturation/point-facturation.component";
import {PointFacturationEditionDialogComponent} from "./clients/points-facturation/edition-dialog/point-facturation-edition-dialog";
import {FacturesClientsComponent} from "./clients/factures/factures-clients.component";
import {FactureClientDetailsDialogComponent} from "./clients/factures/details-dialog-facture-client/facture-client-details-dialog.component";
import {PrintFactureSettingsComponent} from "./clients/factures/details-dialog-facture-client/print-dialog-settings/print-facture-settings.component";
import {FactureClientErrorsComponent} from "./clients/factures/errors/facture-client-errors.component";
import {FacturationClientParametrageComponent} from "./clients/parametrage/facturation-client-parametrage/facturation-client-parametrage.component";
import {LigneParametrageDataGridComponent} from "./clients/parametrage/ligne-parametrage-data-grid/ligne-parametrage-data-grid.component";
import {TransfertEffectivesComponent} from "./clients/factures/transfert-effectives/transfert-effectives.component";
import {TableauDeBordComponent} from "./clients/tableau-de-bord/tableau-de-bord.component";
import {
  AnalyseFinanciereExportComponent
} from "./clients/tableau-de-bord/analyse-financiere-export/analyse-financiere-export.component";
import {TooltipModule} from "primeng/tooltip";
import {FamilleFacturationComponent} from "./clients/famille-facturations/famille-facturation.component";
import {FamilleFacturationEditionComponent} from "./clients/famille-facturations/famille-facturation-edition-dialog/famille-facturation-edition.component";
import {LigneParametrageFamilleFacturationDataGridComponent} from "./clients/parametrage/ligne-parametrage-famille-facturation-data-grid/ligne-parametrage-famille-facturation-data-grid.component";
import {
  FacturationClientFamilleFacturationParametrageComponent
} from "./clients/parametrage/facturation-client-famille-facturation-parametrage/facturation-client-famille-facturation-parametrage.component";
import {FacturationClientPanelComponent} from "./clients/parametrage/facturation-client-panel/facturation-client-panel.component";
import {AddingAreaLigneParametrageComponent} from "./clients/parametrage/adding-area-ligne-parametrage/adding-area-ligne-parametrage.component";
import {ElementFacturableComponent} from "./clients/elements-facturables/element-facturable.component";
import {ElementFacturableEditionDialogComponent} from "./clients/elements-facturables/element-facturable-edition-dialog/element-facturable-edition-dialog.component";
import {FraisFixeComponent} from "./clients/frais-fixes/frais-fixe.component";
import {FraisFixeEditionDialogComponent} from "./clients/frais-fixes/frais-fixe-edition-dialog/frais-fixe-edition-dialog.component";
import {
  FacturationProduitComplementaireParametrageComponent
} from "./clients/parametrage/facturation-produit-complementaire-parametrage/facturation-produit-complementaire-parametrage.component";
import {
  LigneParametrageProduitComplementaireDataGridComponent
} from "./clients/parametrage/ligne-parametrage-produit-complementaire-data-grid/ligne-parametrage-produit-complementaire-data-grid.component";

@NgModule({
  imports: [
    CommonModule,
    FacturesRoutingModule,
    SharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    DxDataGridModule,
    DxAccordionModule,
    DxToolbarModule,

    DxTagBoxModule,
    DxPopupModule,
    DxDateBoxModule,
    DxTextBoxModule,
    DxScrollViewModule,
    DxLookupModule,
    DxNumberBoxModule,
    DxCheckBoxModule,
    DxTextAreaModule,
    DxButtonGroupModule,
    DxListModule,
    DxRadioGroupModule,
    DxSelectBoxModule,
    DxTreeViewModule,
    DxTabPanelModule,
    TooltipModule,
    LigneParametrageProduitComplementaireDataGridComponent,
  ],
  declarations: [
    FacturesRootComponent,
    FacturesFournisseursComponent,
    DialogJoinBonReceptionComponent,
    DialogDetailsInvoiceComponent,
    AvoirFournisseurComponent,
    AvoirFournisseurDetailsDialogComponent,
    PointFacturationComponent,
    PointFacturationEditionDialogComponent,
    FacturesClientsComponent,
    FactureClientDetailsDialogComponent,
    PrintFactureSettingsComponent,
    FactureClientErrorsComponent,
    FacturationClientParametrageComponent,
    LigneParametrageDataGridComponent,
    TransfertEffectivesComponent,
    TableauDeBordComponent,
    AnalyseFinanciereExportComponent,
    FamilleFacturationComponent,
    FamilleFacturationEditionComponent,
    LigneParametrageFamilleFacturationDataGridComponent,
    FacturationClientFamilleFacturationParametrageComponent,
    FacturationClientPanelComponent,
    AddingAreaLigneParametrageComponent,
    ElementFacturableComponent,
    ElementFacturableEditionDialogComponent,
    FraisFixeComponent,
    FraisFixeEditionDialogComponent,
    FacturationProduitComplementaireParametrageComponent
  ]
})
export class FacturesModule {
}
